module.exports = __webpack_public_path__ + "assets/img/今天.c9336d46.png";